import React from "react";
import { ChibanViewer } from "./ChibanViewer";
import { useMapServicePermission } from "@/hooks/useMapServicePermission";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { GetUserMapConfigAPI } from "@/features/map/api/getUserMapConfigAPI";
import { LatLng } from "leaflet";

import { DEFAULT_MAP_LATLNG } from "@/utils/mapLocations";

export const ChibanViewerAccessControl: React.FC = () => {
  const [, permissionLoading] = useMapServicePermission();
  // ユーザーの地図初期設定をAPIから取得
  const { data: userMapConfig, isLoading: isMapConfigLoading } =
    GetUserMapConfigAPI();

  // 地図表示権限とユーザー設定の取得が完了するまでローディング画面を表示
  if (permissionLoading || isMapConfigLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // ユーザーの地図初期設定が存在すればその値を、なければデフォルト値を初期座標として使用
  const initialLatLng = userMapConfig
    ? new LatLng(userMapConfig.mapInitLat, userMapConfig.mapInitLon)
    : DEFAULT_MAP_LATLNG;

  // 初期座標をPropsとして渡し、地図コンポーネントを描画
  return (
    <>
      <ChibanViewer initialLatLng={initialLatLng} />
    </>
  );
};
